import { AbstractStore, StorePartialTrace } from "./AbstractStore";
import { LatestTrace } from "../types";

export class BrowserStore extends AbstractStore {
    async getItem(key: string): Promise<StorePartialTrace> {
        const store = localStorage.getItem(key);

        await this.removeItem(key);

        return this.parseStore(store);
    }

    async setItem(key: string, data: LatestTrace): Promise<number> {
        localStorage.setItem(key, JSON.stringify(this.trace2Item(data)));

        return 0;
    }

    async removeItem(key: string): Promise<number> {
        localStorage.removeItem(key);

        return 0;
    }
}
